import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type IdentityProviderSaveFailedAction = {
	type: 'IDENTITY_PROVIDER_SAVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): IdentityProviderSaveFailedAction => ({
	type: 'IDENTITY_PROVIDER_SAVE_FAILED',
	payload,
});
